/* eslint-disable */

import { useState } from "react";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";

const BrandModal = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const OnCloseModal = props.OnCloseModal;

  //State
  const [form, setForm] = useState({

  });
  const [isUpdate, setIsUpdate] = useState(Id && Id != 0);
  const [error, setError] = useState({

  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async () =>
  {

    // if (isUpdate)
    // {

    //   try
    //   {

    //     setLoading(true);

    //     let response = await processApi.getProcessTemplate(Id);

    //     if (!response.Success)
    //     {

    //       let error = new Error()
    //       error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

    //       throw error;

    //     }


    //     setForm({
    //       _id: response.Data._id,
    //       code: response.Data.code,
    //       label: response.Data.label,
    //       usedByProduct: response.Data.usedByProduct,
    //       process: response.Data.process,
    //       isActive: response.Data.isActive
    //     });


    //     setLoading(false);

    //   } catch (err)
    //   {


    //     setAlert({
    //       Title: getLabel("App", "Error"),
    //       Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
    //       Confirm: getLabel("App", "Ok"),
    //       onConfirm: onFatalError,
    //       Display: true
    //     });

    //   }

    // } else
    // {
    //   //Add
    //   setForm(baseForm);
    //   setLoading(false);
    // }

  };

  const onChangeCode = () => {

  };



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("Model", "Todo")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessTemplate", "code")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["code"] ? "page_modal_body_col_input_error" : "")}
                value={form.code || ""}
                onChange={onChangeCode}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
              />
              {error["code"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["code"]}
                </div>
              }
            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default BrandModal